import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { initialState } from './state';
import { saveTrackingData } from './actions';

export default reducerWithInitialState(initialState).case(saveTrackingData, (state, payload) => ({
    ...state,
    data: {
        ...payload,
        ...{ type: '' }, // TODO Take a closer look whats happening here
    },
}));
